import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    app_locale: 'fr',
  },
  mutations: {
    SET_APP_LOCALE (state, payload) {
      state.app_locale = payload
    },
  },
  modules: modules
})
